<template>
    <div :class="[
        'form__orgunits',
        dragModeActive ? 'form__orgunits--dragmode' : '',
        !orgUnitsId && disabled ? 'is-hidden' : ''
    ]">
        <div class="form__orgunits_top">
            <template v-if="index.length === 0 && orgUnits.length && !disabled">
                <div class="columns columns--margin-1-mobile is-block-mobile is-vcentered">
                    <div class="column is-narrow">
                        <component-button
                            :disabled="isAnyFieldEditable"
                            :class="'form__orgunits_actions_addunit'"
                            :name="'form-org-units-actions-addunit'"
                            :icon="true"
                            :icon-name="'minus-square'"
                            :theme="'default'"
                            :text="true"
                            :size="'tiny'"
                            @click="emitCloseAllGroups"
                        >Collapse all
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :disabled="isAnyFieldEditable"
                            :class="'form__orgunits_actions_addunit'"
                            :name="'form-org-units-actions-addunit'"
                            :icon="true"
                            :icon-name="'plus-square'"
                            :theme="'default'"
                            :text="true"
                            :size="'tiny'"
                            @click="emitOpenAllGroups"
                        >Expand all
                        </component-button>
                    </div>
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <form-text
                            :label="''"
                            :name="''"
                            :placeholder="'Search organisation units'"
                            v-model="baseSearchQuery"
                        />
                    </div>
                </div>
            </template>
        </div>
        <form-orgunits-item
            v-for="(orgUnit, orgUnitIndex) in orgUnits"
            :key="`form-org-unit-${orgUnitIndex}-${rerenderIndex}`"
            :index="[...index, orgUnitIndex]"
            :item="orgUnit"
            :drag-mode-active="dragModeActive"
            :drag-item-id="dragItemId"
            :is-any-editable="isAnyFieldEditable"
            :disabled="disabled"
            :excluded-names="usedUnitNames"
            :search-query="baseSearchQuery || searchQuery"
            @emit-add="emitAdd"
            @emit-remove="emitRemove"
            @emit-move="emitMove"
        ></form-orgunits-item>
        <template v-if="index.length === 0 && orgUnitCustomerId && !disabled">
            <div class="form__orgunits_addactions">
                <component-button
                    :disabled="isAnyFieldEditable"
                    :class="'form__orgunits_actions_addunit'"
                    :name="'form-org-units-actions-addunit'"
                    :icon="true"
                    :icon-name="'plus-circle'"
                    :theme="'default'"
                    :text="true"
                    :size="'tiny'"
                    @click="emitAdd"
                >Add unit
                </component-button>
            </div>
        </template>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import FormOrgunitsItem from '@/components/default/forms/FormOrgUnitsItem'
import FormText from '@/components/default/forms/FormText'

export default {
  name: 'form-orgunits',
  components: { FormText, FormOrgunitsItem, ComponentButton },
  data () {
    return {
      dragModeActive: false,
      dragItemId: '',
      dragItemType: '',
      rerenderIndex: 0,
      isAnyNameEditable: false,
      isAnyManagersEditable: false,
      baseSearchQuery: ''
    }
  },
  props: {
    orgUnits: {
      type: Array,
      required: true
    },
    index: {
      type: [Array, Number],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchQuery: {
      type: String
    }
  },
  computed: {
    isAnyFieldEditable () {
      return this.isAnyNameEditable || this.isAnyManagersEditable
    },
    orgUnitCustomerId () {
      return this.$store.getters.getLmsSuperadminOrgUnitsWorkspaceId
    },
    orgUnitsId () {
      return this.$store.getters.getLmsSuperadminOrgUnitsId
    },
    usedUnitNames () {
      return this.orgUnits.map(obj => obj.name)
    }
  },
  watch: {
    baseSearchQuery () {
      this.emitOpenAllGroups()
    }
  },
  methods: {
    emitAdd (data) {
      this.$emit('emit-add', data)
    },
    emitRemove (data) {
      this.$emit('emit-remove', data)
    },
    emitMove (data) {
      this.$emit('emit-move', data)
    },
    emitOpenAllGroups () {
      this.$eventBus.$emit('form-org-units-open-all-groups')
    },
    emitCloseAllGroups () {
      this.$eventBus.$emit('form-org-units-close-all-groups')
    },
    enableDragMode (data) {
      this.dragItemId = data
      this.dragModeActive = true
    },
    disableDragMode () {
      this.dragItemId = ''
      this.dragModeActive = false
    },
    enableNameEditable () {
      this.isAnyNameEditable = true
    },
    disableNameEditable () {
      this.isAnyNameEditable = false
    },
    enableManagersEditable () {
      this.isAnyManagersEditable = true
    },
    disableManagersEditable () {
      this.isAnyManagersEditable = false
    }
  },
  mounted () {
    this.$eventBus.$on(`form-org-units-dragstart`, this.enableDragMode)
    this.$eventBus.$on(`form-org-units-dragend`, this.disableDragMode)
    this.$eventBus.$on(`form-org-units-enable-name-editable`, this.enableNameEditable)
    this.$eventBus.$on(`form-org-units-disable-name-editable`, this.disableNameEditable)
    this.$eventBus.$on(`form-org-units-enable-managers-editable`, this.enableManagersEditable)
    this.$eventBus.$on(`form-org-units-disable-managers-editable`, this.disableManagersEditable)
  },
  beforeDestroy () {
    this.$eventBus.$off(`form-org-units-dragstart`)
    this.$eventBus.$off(`form-org-units-dragend`)
    this.$eventBus.$off(`form-org-units-enable-name-editable`)
    this.$eventBus.$off(`form-org-units-disable-name-editable`)
    this.$eventBus.$off(`form-org-units-enable-managers-editable`)
    this.$eventBus.$off(`form-org-units-disable-managers-editable`)
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formorgunits";
</style>
